import { theme } from 'Assets/Styles/theme'

export default ({ props }) => {
  const accentColor = props.color || theme.colors.primary

  return {
    infoBlock: {
      marginBottom: '10px',
    },

    submissionPopup: {
      maxWidth: '700px',
    },

    content: {
      marginTop: '12px',
    },

    textArea: {
      marginTop: '12px',
      width: '100%',
      resize: 'none',
      borderRadius: '4px',
      padding: '10px',
    },

    button: {
      '&:not(:last-child)': {
        marginRight: 20,
      },
    },
    filledButton: {
      borderRadius: '4px',
      backgroundColor: accentColor,
      color: theme.colors.white,
      letterSpacing: '0.8px',
      filter: 'brightness(1)',
      transition: 'filter .3s',
      '&:hover': {
        backgroundColor: accentColor,
        filter: 'brightness(1.3)',
      },
    },
    error: {
      color: 'red',
    },
  }
}
